import { useContext } from 'react'
import { ZendeskProviderContext } from '../../providers'

export const useZendesk = () => {
  return useContext(ZendeskProviderContext)
}
